import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { CanActivateChildGuard } from 'src/app/core/guards/can-activate-child.guard';
import { ListDocumentTemplateComponent } from './list-document-template/list-document-template.component';
import { DocumentTemplateFormComponent } from './document-template-form/document-template-form.component';

const routes: Routes = [
  {
    path: '',
    component: ListDocumentTemplateComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./list-document-template/list-document-template.module').then(m => m.ListDocumentTemplateModule),
  },
  {
    path: 'create',
    component: DocumentTemplateFormComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document-template-form/document-template-form.module').then(m => m.DocumentTemplateFormModule),
  },
  {
    path: 'update/:id',
    component: DocumentTemplateFormComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./document-template-form/document-template-form.module').then(m => m.DocumentTemplateFormModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AsDocumentManagementRoutingModule { }
